<script lang="ts" setup>
    import { ref, onMounted, watch } from 'vue'
    // import axios from '@/utils/apiClient'

    import axios from '@/utils/apiClient'

    const props = defineProps({
        modelValue: {
            type: Number,
            default: null,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    })

    interface Company {
        id: number
        companyName: string
    }

    const emit = defineEmits(['update:modelValue'])

    const companies = ref<Company[]>([])
    const value = ref(props.modelValue)

    const fetch = async () => {
        const res = await axios.get('Company')
        companies.value = res.data
    }

    onMounted(() => {
        fetch()
    })

    watch(
        () => props.modelValue,
        newValue => {
            value.value = newValue
        }
    )

    watch(value, newValue => {
        emit('update:modelValue', newValue)
    })
</script>

<template>
    <el-select
        size="large"
        filterable
        class="w-100"
        v-model="value"
        placeholder="Select Company"
        :clearable="clearable"
    >
        <el-option v-for="company in companies" :key="company.id" :label="company.companyName" :value="company.id">
            <!-- <div>{{ employee.fullName  }} <span class="text-caption">( {{ employee.department.departmentName }} )</span></div> -->
        </el-option>
        <template #prefix>
            <i class="ti ti-user"></i>
        </template>
    </el-select>
</template>
